import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthPermissions } from 'skipify-types';

import { useMerchant } from '../contexts/MerchantContext';
import { configurationPaths } from '../util/constants';
import { buildUrlWithMerchantId } from '../util/helpers';

/**
 * Child-merchant-only users on a parent org (GET merchant returns no partnerMerchantId) may only
 * use the Overview landing (and Create Child Merchant when they have create:merchants). Redirect
 * any other URL (e.g. /settings/merchant-webhooks) to /settings.
 */
export const ChildMerchantParentRouteGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { merchantId, isChildMerchantOnlyUser, partnerMerchantId, canAccess } = useMerchant();

  useEffect(() => {
    if (!merchantId || !isChildMerchantOnlyUser) return;
    if (partnerMerchantId === undefined) return;
    if (partnerMerchantId !== null) return;

    const path = location.pathname.replace(/\/$/, '') || '/';
    if (path === configurationPaths.SETTINGS) return;
    if (
      path === configurationPaths.CREATE_CHILD_MERCHANT &&
      canAccess(AuthPermissions.CREATE_MERCHANTS)
    ) {
      return;
    }

    navigate(buildUrlWithMerchantId(configurationPaths.SETTINGS, merchantId), { replace: true });
  }, [
    merchantId,
    isChildMerchantOnlyUser,
    partnerMerchantId,
    location.pathname,
    navigate,
    canAccess,
  ]);

  return null;
};
